module.exports = __webpack_public_path__ + "static/media/Newmodal.5fe53dd0.svg";